import { IComponentController } from 'angular';
import { IMonoOccurrence } from '../../../../core/services/mono-occurrence.service';
import { IDataType } from '../../../../core/services/data-types/data-type.service';
import { IDialog } from '../../../../core/services/dialog.service';
import { IEcranContextController } from '../../../../core/behaviors/ex-ecran-context/ex-ecran-context.behavior';
import { IDefaultsService } from '../../../../core/services/utils/defaults.service';

interface IComposantButtonHistoriqueColonne extends IComponentController {
    ecranContextCtrl: IEcranContextController;
    col: string;
    readonly: boolean;
    data: any;
    occurrence: IMonoOccurrence;
    dataType: IDataType;
    resourceParams: any;
    reloadData: any;
    fonction: string | undefined;
    fonctionHidden: boolean;
    openHistoriqueColonne(event: MouseEvent): void;
}

/* @ngInject */
export default function ButtonHistoriqueColonneController(DialogHistoriqueColonne: IDialog,
    defaults: IDefaultsService) {

    const vm: IComposantButtonHistoriqueColonne = this;
    vm.$onInit = $onInit;
    vm.openHistoriqueColonne = openHistoriqueColonne

    function $onInit() {
        defaults(vm, {
            fonctionHidden: false
        });

        const fonctionName = vm?.fonction;
        if (fonctionName) {
            const fonctions = vm?.ecranContextCtrl?.ecranDetails?.fonctions;
            if (fonctions) {
                const fonction = fonctions[fonctionName.toUpperCase()] || vm.occurrence && fonctions[`${vm.occurrence.mnemonique}.${fonctionName}`.toUpperCase()];
                vm.fonctionHidden = Boolean(fonction && !fonction.flgacc);
            }
        }
    }

    function openHistoriqueColonne(event: MouseEvent) {
        DialogHistoriqueColonne.show({
            targetEvent: event,
            locals: {
                srccod: vm.occurrence.srccod,
                cleintref: vm.data[vm.occurrence.cleint],
                col: vm.col,
                dataType: vm.dataType,
                libelle: (vm.occurrence.libelles as any)[vm.col.toUpperCase()],
                readonly: vm.readonly,
                ecranContext: vm.ecranContextCtrl,
                resourceParams: vm.resourceParams instanceof Function ? vm.resourceParams(vm.data) : vm.resourceParams,
                reloadData: vm?.reloadData || false
            }
        }).finally(() => vm.occurrence.softUpdateData());
    }
}
